
import { Component, Prop, Watch, Vue, PropSync } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import { getProSchListByProxyId, insertProSch } from '@/api/agentcenter'
// import { checkUntreated } from '@/api/agentcenter'
import { getStudySelect, getBusinessAll } from '@/api/common/common'

@Component({
  name: 'grant',
  components: {
    SimpleTable,
    DictSelect
  }
})

export default class Grant extends Vue {
  @PropSync('visible', { type: Boolean })
  private dialogVisible!: boolean

  @Prop({ type: Object })
  private data!: object|any

  @Prop({ type: Boolean })
  private visible!: boolean

  private selecteds = []

  private iVisible = this.visible

  @Watch('visible')
  private visibleChange (val: any) {
    this.iVisible = val
  }

  private form: any = {}

  private async businessChange () {
    this.form.studyId = ''
    await getStudySelect({
      ...this.form
    }).then((res: any) => {
      this.studyData = res.object.list
    })
  }

  private columns = [{
    prop: 'schoolCode',
    label: '院校代码'
  },
  {
    prop: 'schoolName',
    label: '院校名称'
  },
  {
    prop: 'businessName',
    label: '业务类型'
  },
  {
    prop: 'studyName',
    label: '学习类型'
  }]

  private tableData = {
    list: [],
    totalCount: 0
  }

  private businessData: any[] = []

  private studyData: any[] = []

  private pagination = {
    currentPage: 1,
    pageSize: 10
  }

  private rowClick (row: any) {
    let flag = !1
    this.selecteds.map((val: any) => {
      if (row.id === val.schoolId) {
        flag = !0
      }
    })
    flag || this.selecteds.push({
      schoolId: row.id,
      schoolName: row.schoolName
    } as never)
  }

  private async close (id: any) {
    // await checkUntreated({
    //   schoolId: id,
    //   tbsUserId: this.data.tbsUserId
    // }).then((res: any) => {
    //   if (res.code === 10000) {
    //     if (res.object.isDel) {
    //       this.$alert('删除失败，存在未结算数据')
    //     } else {
    //       const temp = this.selecteds
    //       this.selecteds = temp.filter((val: any) => val.schoolId !== id)
    //     }
    //   } else {
    //     this.$message('请求失败，请联系管理员')
    //   }
    // })
    const temp = this.selecteds
    this.selecteds = temp.filter((val: any) => val.schoolId !== id)
  }

  private handleClose (done: Function) {
    this.selecteds = []
    done()
  }

  private async onSubmit () {
    // do
    const datas: any = []
    if (this.selecteds.length === 0) {
      this.$message.error('请选择至少一个院校')
      return
    }
    this.selecteds.map((val: any) => {
      datas.push({
        proxyId: this.data.id,
        schoolId: val.schoolId
      } as never)
    })

    await insertProSch(datas as any).then((res: any) => {
      if (res.code === 10000) {
        this.$message(res.message)
      }
    })
  }

  private open () {
    this.form = {
      businessId: '',
      studyId: '',
      schoolName: '',
      state: 1
    }
    this.initQueryData()
    this.initTable({
      currentPage: 1,
      pageSize: 10
    })
  }

  private async initTable (pagination: any) {
    const proTypes: any[] = []
    this.data.businessIds.split(',').map((v: any) => {
      proTypes.push({
        businessId: v
      })
    })
    await getProSchListByProxyId({
      proxyId: this.data.id,
      proTypes: proTypes,
      ...this.form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.tableData = {
        list: res.object.list,
        totalCount: res.object.totalCount
      }
      this.selecteds.length === 0 && (this.selecteds = res.object.proSchList)
    })
  }

  private async initQueryData () {
    await getBusinessAll({
      ...this.form
    }).then((res: any) => {
      if (res.code === 10000) {
        this.businessData = res.object
      }
    })
    await getStudySelect({
      ...this.form
    }).then((res: any) => {
      if (res.code === 10000) {
        this.studyData = res.object.list
      }
    })
  }

  private roeClassName ({ row }: any) {
    const flag = this.selecteds.filter((v: any) => v.schoolId === row.id)
    return flag.length > 0 ? 'active' : ''
  }
}
